import { fetchFactory, fetch as fetchMiddleware, timeout as timeoutMiddleware, } from "@cultureamp/fetch";
/**
 * A fetch function that will process fetch and timeout middlewares
 */
export const fetchConfig = fetchFactory([timeoutMiddleware, fetchMiddleware], {
    timeout: 3000,
});
